import { Grid ,Dialog} from "@material-ui/core";
import { makeStyles } from "@material-ui/core";
import React, { useEffect, useLayoutEffect } from "react";
import Image from "../../assests/BgFinal.png";
import { useMediaQuery } from "react-responsive";
import EContentSection from "./e_content-section/e_content-section";
import EFooterSection from "./e_footer-section/e_footer-section";
import ELoginSection from "./e_login-section/e_login-section";
import EFaqs from "./e_content-section/e_faqs/view/_faqs";
import EAnnouncements from "./e_content-section/e_announcements/view/_announcements";
import EUsefulLinks from "./e_content-section/e_useful-links/view/_useful-links";
import { commonService } from "../../services";
import { useState } from "react";
import { useSelector,useDispatch } from "react-redux";
import { useRef } from "react";
import DPDCLOGO from "../../assests/DPDC_LOGO.png";
import { desktopbackgroundimg } from "./model/action";


const useStyles = makeStyles((theme) => ({
  backgroundImage: {
    backgroundSize: "cover",
    width: "100%",
    height: "100vh",
    overflowX: "hidden",
    objectFit: "cover !important",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
  },
  mt5: {
    margin: "0%",
  },
  '@global': {
    html: {
      height: "100%"
    },
    body: {
      height: "100%",
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      backgroundAttachment: "fixed"
    }
  },
  footerSection: {
    color: theme.palette.eWhite.base,
    position: "fixed",
    bottom: 0,
    [theme.breakpoints.up("xs")]: {
      position:"relative",
    },
  },
  dilog: {
    margin:'0.5em 0',
    "& .MuiDialog-container":{
      backgroundColor:theme.palette.eWhite.base+"!important",
    },
    position:"absolute",
    zIndex:3066660 +"!important"
  },
  smBackground:{
    background: theme.palette.ePrimary.base,
  }
}));

let bgFallBack = {};
let backgroundImg = {};

function EHomePage(props) {
  const dispatch=useDispatch()
  const [allLoading, setAllLoading] = useState(true);
  const announcementLoading = useSelector((store) => store?.loginLodingState?.announcementLoading);
 const appContentApiLoading = useSelector((store) => store?.loginLodingState?.appContentApiLoading);
 const contentloading = useSelector((store) => store?.loginLodingState?.contentloading);
 const faqLoading = useSelector((store) => store?.loginLodingState?.faqLoading)
 const imgloading = useSelector((store) => store?.loginLodingState?.imgloading)
 const linksLoading = useSelector((store) => store?.loginLodingState?.linksLoading)
 const desktopBgIMGLoading = useSelector((store) => store?.loginLodingState?.desktopBgIMGLoading)
  useEffect(()=>{
  if(!desktopBgIMGLoading && !announcementLoading && !appContentApiLoading && contentloading===false && !faqLoading  && !linksLoading &&  !imgloading){
    setAllLoading(false)
  }
},[desktopBgIMGLoading,announcementLoading ,appContentApiLoading ,contentloading ,faqLoading ,imgloading,linksLoading])
let loginRef = useRef(null);
  const classes = useStyles();
  
  const [bgImg, setBgImg] = useState("");
  useEffect(() => {
    window.RocketChat(function () {
      this.showWidget();
    });
  });
  backgroundImg = useSelector(
    (store) =>
      store?.parametersWidgets?.ParameterLookup?.E_LOGIN_PAGE_BACKGROUND_IMAGE
  );

  bgFallBack = useSelector(
    (state) => state?.labels?.data?.getLabels?.E_LOGIN_PAGE_BACKGROUND_IMAGE
  );
  const browserName = useSelector((store) => store?.browserDetect?.browserName);
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 640px)" });

  useEffect(() => {
    if(backgroundImg){
      dispatch(desktopbackgroundimg(true))
      commonService.getAssestUrl(backgroundImg).then((res) => {
        setBgImg(res)
        dispatch(desktopbackgroundimg(false))
        // const body = document.querySelector("body");
        // body.style.backgroundImage = `url(${res.assetPath})`;
      });
  }}, [backgroundImg]);
  return (
    <>
     { allLoading ?  <Dialog open={allLoading} className={classes.dilog}><img height="150vh" style={{margin:'0.5em 0'}} src={DPDCLOGO} alt="Loading."  /></Dialog> : null}
      
      {isTabletOrMobile  ? (
        <React.Fragment>
           <Grid
            container
            rowSpacing={2}
            colSpacing={2}
            className={classes.smBackground}
          >
            <Grid container>
              <Grid item xs={12} md={6}>
                <ELoginSection />
              </Grid>

              <Grid item xs={12} md={6} style={{width:"inherit"}}>
                <EContentSection tab={props?.location?.state?.tab}/>
              </Grid>                
              {/* <Grid item xs={12} md={6}>
                <EFaqs />
              </Grid>

              <Grid item xs={12} md={6}>
                <EAnnouncements />
              </Grid>

              <Grid item xs={12} md={6}>
                <EUsefulLinks />
              </Grid>  */}
            </Grid> 

            <Grid item xs={12} className={classes.footerSection}>
              <EFooterSection />
            </Grid>
          </Grid>
        </React.Fragment>
        // 
      ) : (
        <Grid
          container
          className={classes.backgroundImage}
          justify="space-around"
          spacing={0}
          alignContent="center"
          style={{overflowY: browserName === "firefox" ? "auto" : "overlay" ,backgroundImage: `url(${bgImg.assetPath})`}}
        >
          <Grid item xs={12}>
            <Grid
              container
              justify="space-around"
              spacing={2}
              alignContent="center"
              className={classes.mt5}
            >
              <Grid item sm={5} md={5}>
                <EContentSection tab={props?.location?.state?.tab}/>
              </Grid>
              <Grid item sm={5} md={4} lg={3}>
                <ELoginSection
                  id="login-container"
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} className={classes.footerSection}>
            <EFooterSection />
          </Grid>
        </Grid>
      )}
    </>
  );
}

export default EHomePage;
